<template>
    <section class="welcome-banner bg-design">
        <div class="page-container">
            <div class="welcome-copy">
               <h1 class="text-white mb-10">Earn cashback </h1>
               <h1 class="text-white mb-10">shopping where you love.</h1>
                <!-- <figure class="featured mb-20">
                    <img src="images/txt-the-possibilities.png" alt="">
                </figure> -->
                <h1 class="text-white mb-10" v-if="$route.name!=='register'">Beyond Ulta Beauty Rewards<sup>&#8482;</sup></h1>
                <p class="text-white">Bring on the offers.</p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "InnerWelcomeBannerComponent",
    methods: {

    }
}
</script>
